import { type HttpClientConfig } from 'core/infra/http/HttpClient'
import { ShipperGuideClient } from 'core/infra/http/ShipperGuideClient'

import { TokenExpiredError } from 'rate-command-center/domain/errors/TokenExpiredError'
import {
  isTokenExpiredError,
  type ResponseError,
} from 'rate-command-center/infra/RateCommandCenterRepository'

import { PendingTendersRepository } from '../infra/PendingTendersRepository'

export type GetPendingTendersFactoryDependencies = {
  repository: PendingTendersRepository
  config?: Partial<HttpClientConfig>
}

type Params = {
  token: string
  config?: Partial<HttpClientConfig>
}

export function getPendingTendersFactory({
  repository,
  config,
}: GetPendingTendersFactoryDependencies) {
  return async function getPaginatedRatesByStatus(params: Params) {
    try {
      return await repository.getPendingTenders({
        ...params,
        config,
      })
    } catch (error) {
      if (isTokenExpiredError(error as ResponseError)) {
        throw new TokenExpiredError()
      } else {
        throw new Error('Could not get rates', { cause: error as Error })
      }
    }
  }
}

export function getPendingTenders({ token, config }: Params) {
  const httpClient = new ShipperGuideClient()
  const repository = new PendingTendersRepository({ httpClient })
  const newGetPendingTenders = getPendingTendersFactory({
    repository,
    config,
  })
  return newGetPendingTenders({ token, config })
}
